var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 65,
    viewBox: "0 0 91 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3.79167C0 1.69759 1.69759 0 3.79167 0H18.9583C20.7655 0 22.3216 1.27546 22.6763 3.04753L25.8608 18.9583H25.9536L27.4896 26.5417H27.3786L32.8379 53.8179L32.839 53.8234C33.0124 54.6962 33.4872 55.4803 34.1804 56.0383C34.8736 56.5963 35.741 56.8927 36.6307 56.8757C36.6549 56.8752 36.6791 56.875 36.7033 56.875H73.5583C73.5825 56.875 73.6068 56.8752 73.631 56.8757C74.5207 56.8927 75.3881 56.5963 76.0813 56.0383C76.7712 55.4829 77.2449 54.7035 77.4202 53.8355L77.4226 53.8234L82.6252 26.5417H82.5398L84.084 18.9583H87.2083C88.3383 18.9583 89.4095 19.4623 90.1298 20.333C90.8501 21.2037 91.1446 22.3503 90.9329 23.4603L84.8662 55.2724L84.8607 55.3008C84.3406 57.9193 82.9161 60.2714 80.8365 61.9455C78.7674 63.6111 76.1809 64.4999 73.5258 64.4583H36.7359C34.0808 64.4999 31.4943 63.6111 29.4251 61.9455C27.3464 60.2721 25.9222 57.9211 25.4016 55.3038L25.401 55.3008L19.0675 23.657C19.0418 23.5523 19.0205 23.4459 19.0037 23.338L15.8504 7.58333H3.79167C1.69759 7.58333 0 5.88575 0 3.79167Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon2);
export default __webpack_public_path__ + "static/media/cartIcon2.49404e41721d2d6f6be533d3a7c42c25.svg";
export { ForwardRef as ReactComponent };